import React from "react";
import { ArrowRight, ShieldCheck, Phone } from "lucide-react";
import { COMPANY, STATS } from "@/lib/site";

const HERO_IMG = "/img/hero-officina.jpg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#0a0a0a]"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Officina meccanica motore"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
        <div className="absolute inset-0 grid-pattern opacity-50" />
      </div>

      {/* Side label */}
      <div data-testid="hero-side-label" className="hidden xl:flex absolute right-4 top-1/2 -translate-y-1/2 [writing-mode:vertical-rl] text-zinc-500 text-xs uppercase tracking-[0.4em] font-mono items-center gap-3 z-10">
        <span className="h-12 w-px bg-zinc-600" />
        Made in Italy · Est. 1990
      </div>

      {/* Right horizontal phone */}
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        className="hidden lg:flex absolute right-8 top-28 text-zinc-300 hover:text-white text-xs uppercase tracking-[0.3em] font-mono items-center gap-3 transition-colors z-10 bg-black/40 backdrop-blur-sm border border-white/10 px-4 py-2"
      >
        <Phone size={12} className="text-[#E63946]" />
        Chiama Ora · {COMPANY.phone}
      </a>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24 lg:pt-48 lg:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 fade-up" style={{ animationDelay: "60ms" }}>
            {/* Badge */}
            <div className="inline-flex items-center gap-3 border border-white/15 px-4 py-2 mb-8 bg-black/40 backdrop-blur-sm">
              <ShieldCheck size={14} className="text-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-200">
                {COMPANY.warranty}
              </span>
            </div>

            <h1 className="font-heading font-black leading-[0.85] tracking-tighter text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
              MOTORI.
              <br />
              <span className="text-[#E63946]">CAMBI.</span>
              <br />
              MUSATE.
            </h1>

            <p className="mt-8 max-w-2xl text-lg md:text-xl text-zinc-300 leading-relaxed">
              Motori usati e revisionati, cambi manuali e automatici, musate di
              altissima qualità. Affidati all'esperienza dei nostri tecnici per
              rimettere in strada il tuo veicolo con sicurezza e prestazioni
              ottimali.
            </p>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="#preventivo"
                data-testid="hero-cta-preventivo"
                className="group inline-flex items-center gap-3 px-8 py-4 bg-[#E63946] hover:bg-[#c81d25] text-white font-bold uppercase tracking-widest text-sm transition-all duration-300"
              >
                Richiedi Preventivo
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <a
                href="#servizi"
                data-testid="hero-cta-servizi"
                className="inline-flex items-center gap-3 px-8 py-4 border border-white/25 hover:border-white text-white font-bold uppercase tracking-widest text-sm transition-all duration-300"
              >
                Esplora i Servizi
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div
              className="border-l border-white/10 pl-6 lg:pl-8 fade-up"
              style={{ animationDelay: "240ms" }}
            >
              <div className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-500 mb-4">
                Standard MotorieRicambi
              </div>
              <div className="grid grid-cols-2 gap-y-6 gap-x-4">
                {STATS.map((s, i) => (
                  <div key={i}>
                    <div className="font-heading font-black text-4xl text-white tracking-tighter">
                      {s.value}
                      <span className="text-[#E63946]">{s.suffix}</span>
                    </div>
                    <div className="mt-1 text-xs uppercase tracking-wider text-zinc-400">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom red bar */}
      <div className="absolute bottom-0 left-0 right-0 h-1 red-bar z-10" />
    </section>
  );
}
